<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>

<div class="card">
  <button
    *ngIf="flagIns"
    pButton
    type="button"
    icon="pi pi-plus"
    iconPos="left"
    (click)="inserirAnexo()"
    [disabled]="showForm"
    style="width: 130px; margin: 3px"
    class="p-button-info"
    label="Inserir"
  ></button>
</div>
<div *ngIf="showForm">
  <form [formGroup]="anexoAddForm" (submit)="saveAnexo()">
    <p-fileUpload
      #fileUpload
      id="atividadeAnexo"
      name="atividadeAnexo[]"
      [multiple]="false"
      [showUploadButton]="false"
      [showCancelButton]="false"
      [customUpload]="true"
      chooseLabel="Adicionar"
      cancelLabel="Cancelar"
      [accept]="'.xls,.xlsx,.png,.jpg,.jpeg,.bmp,.gif,.pdf,image/*,application/pdf'"
      (onSelect)="onFileSelect($event)"
      (onRemove)="onFileRemove($event)"
    >
    </p-fileUpload>
    <div class="mt-4 mb-1"><b class="ml-3">Extensões válidas:</b> .jpg, .jpeg, .png, .pdf, .xls e .xlsx</div>

    <div class="card">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div class="flex flex-col">
          <label for="nome">Nome:</label>
          <input
            formControlName="nome"
            id="nome"
            style="width: 100%"
            type="text"
            aria-describedby="nome-help"
            pInputText
          />
          <small class="text-red-500" *ngIf="anexoAddForm.get('nome')?.errors?.['required']"
            >Nome do Arquivo é obrigatório.</small
          >
          <small class="text-red-500" *ngIf="anexoAddForm.get('nome')?.errors?.['maxlength']"
            >Máximo de caracteres é 100.</small
          >
        </div>
        <div class="flex flex-col">
          <label for="descricao">Descrição:</label>
          <input
            formControlName="descricao"
            id="descricao"
            style="width: 100%"
            type="text"
            aria-describedby="descricao-help"
            pInputText
          />
          <small class="text-red-500" *ngIf="anexoAddForm.get('descricao')?.errors?.['required']"
            >Descrição do Arquivo é obrigatório.</small
          >
          <small class="text-red-500" *ngIf="anexoAddForm.get('descricao')?.errors?.['maxlength']"
            >Máximo de caracteres é 250.</small
          >
        </div>
      </div>
      <div class="flex flex-col">
        <label for="observacao">Observação:</label>
        <input
          formControlName="observacao"
          id="observacao"
          style="width: 100%"
          type="text"
          aria-describedby="observacao-help"
          pInputText
        />
        <small class="text-red-500" *ngIf="anexoAddForm.get('observacao')?.errors?.['maxlength']"
          >Máximo de caracteres é 500.</small
        >
      </div>
    </div>

    <div class="card">
      <div class="formgroup-inline">
        <p-button
          label="Limpar Campos"
          icon="pi pi-trash"
          class="mr-2"
          (click)="resetAnexoAddForm()"
          severity="danger"
        ></p-button>
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          (click)="inserirAnexo()"
          severity="primary"
          variant="outlined"
          class="mr-2"
        ></p-button>
        <p-button
          type="submit"
          [disabled]="anexoAddForm.invalid"
          label="Confirmar"
          icon="pi pi-check"
          class="mr-2"
          severity="success"
        ></p-button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="!showForm">
  <div class="card">
    <p-table
      styleClass="p-datatable-gridlines"
      [value]="atividadeAnexos"
      [scrollable]="true"
      scrollHeight="300px"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr class="font-grid-atividade-header">
          <th>Nome</th>
          <th>Descrição</th>
          <th>Data</th>
          <th>Observação</th>
          <th>Arquivo</th>
          <th class="p-text-center">Download</th>
          <th *ngIf="flagDel" class="p-text-center">Excluir</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-atividadeAnexo>
        <tr class="font-grid-atividade">
          <td class="break-word">{{ atividadeAnexo.nome }}</td>
          <td class="break-word">{{ atividadeAnexo.descricao }}</td>
          <td>{{ atividadeAnexo.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td class="break-word">{{ atividadeAnexo.observacao }}</td>
          <td class="break-word">{{ atividadeAnexo.nomeArquivo }}</td>
          <td class="p-text-center">
            <a target="_blank" [href]="atividadeAnexo.caminhoArquivo" download
              ><span><i class="pi pi-download" (click)="download()"></i></span
            ></a>
          </td>
          <td *ngIf="flagDel" class="p-text-center" class="cursor-pointer text-cyan-500">
            <span><i class="pi pi-trash" (click)="deleteAnexo(atividadeAnexo.idAtividadeAnexo, $event)"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
